import { CountryDataResponse } from "@/dashboard-api-types/api/countryData.types";
import { EpidemiologyDataResponse } from "@/dashboard-api-types/api/epidemiologyData.types";

export const formatCountryData = (data: CountryDataResponse) => {
  return [
    {
      titleRow: "Country Name",
      content: data?.country_LocName || "N/A",
    },
    {
      titleRow: "UN Location Code",
      content: data?.country_LocCode || "N/A",
    },
    {
      titleRow: "ISO3 Alpha-code",
      content: data?.country_ISO3Alpha || "N/A",
    },
    {
      titleRow: "ISO2 Alpha-code",
      content: data?.country_ISO2Alpha || "N/A",
    },
    {
      titleRow: "Development Label",
      content: data?.country_DevelopLabel || "N/A",
    },
    {
      titleRow: "Income Label",
      content:
        data?.country_IncomeLabel && data?.country_CountryClass
          ? `${data?.country_IncomeLabel}, Country class: ${data?.country_CountryClass}`
          : "N/A",
    },
    {
      titleRow: "WHO Region",
      content: data?.country_WHOregion || "N/A",
    },
    {
      titleRow: "Continent",
      content: data?.country_Continent || "N/A",
    },
    {
      titleRow: "IDF Region",
      content: data?.country_IDFRegion || "N/A",
    },
    {
      titleRow: "Remarks",
      content: data?.country_NoteText || "No remarks",
    },
  ];
};

const ageGroups = [
  { age: "0", label: "Age 0-19" },
  { age: "20", label: "Age 20-39" },
  { age: "40", label: "Age 40-59" },
  { age: "60", label: "Age 60+" },
  { age: "total", label: "Total" },
];

const roundOrNA = (
  value: number | undefined,
  precision: number = 0,
  nullValue: number = 0
): string => {
  if (value === undefined || value === null || value == 0) value = nullValue;
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(Number(value));
};

const getValue = (dataset: Record<string, any> | undefined, age: string, year: number): string => {
  const value = dataset?.[age]?.[year]?.value;
  return roundOrNA(value);
};

export const formatEpidemiologyDataToTable = (data: EpidemiologyDataResponse, year: number) => {
  const { incidenceData, prevalenceData, deathData } = data || {};

  const rows = ageGroups.map(({ age, label }) => ({
    titleRow: label,
    incidence: getValue(incidenceData?.incCasesData, age, year),
    deaths: getValue(deathData?.deathsCoreData, age, year),
    prevalence: getValue(prevalenceData?.prevCoreData, age, year),
  }));

  const inc0 = incidenceData?.incCasesData?.["0"]?.[year]?.value;
  const prev0 = prevalenceData?.prevCoreData?.["0"]?.[year]?.value;
  const ratio = inc0 != null && prev0 != null ? roundOrNA(prev0 / inc0, 1) : "N/A";

  rows.push({
    titleRow: "PREV/INC, Age 0-19:",
    incidence: null,
    deaths: null,
    prevalence: ratio,
  });

  const totalInc = incidenceData?.incCasesData?.["total"]?.[year]?.value;
  const totalPrev = prevalenceData?.prevCoreData?.["total"]?.[year]?.value;
  const totalRatio =
    totalInc != null && totalPrev != null ? roundOrNA(totalPrev / totalInc, 1) : "N/A";

  rows.push({
    titleRow: "PREV/INC, All:",
    incidence: null,
    deaths: null,
    prevalence: totalRatio,
  });

  return rows;
};
